<template>
  <BeakerIcon v-if="name === 'beaker'" class="h-6 w-6" v-bind="$attrs" />
  <EllipsisHorizontalIcon v-if="name === 'ellipsis-horizontal'" class="h-6 w-6" v-bind="$attrs" />
  <EllipsisVerticalIcon v-if="name === 'ellipsis-vertical'" class="h-6 w-6" v-bind="$attrs" />
  <Bars3Icon v-if="name === 'bars-3'" class="h-6 w-6" v-bind="$attrs" />
  <XMarkIcon v-if="name === 'x-mark'" class="h-6 w-6" v-bind="$attrs" />
</template>

<script setup lang="ts">
import {
  BeakerIcon,
  EllipsisHorizontalIcon,
  EllipsisVerticalIcon,
  XMarkIcon,
  Bars3Icon,
} from '@heroicons/vue/24/outline';

defineProps<{
  name: string;
}>();
</script>
